import { DaysOfWeekEnum } from '../../enums';

export interface DayOfWeek {
	id: DaysOfWeekEnum;
	index: number;
	shortName: string;
}

export const DAYS_OF_WEEK: DayOfWeek[] = [
	{
		id: DaysOfWeekEnum.Sunday,
		index: 0,
		shortName: 'Sun',
	},
	{
		id: DaysOfWeekEnum.Monday,
		index: 1,
		shortName: 'Mon',
	},
	{
		id: DaysOfWeekEnum.Tuesday,
		index: 2,
		shortName: 'Tue',
	},
	{
		id: DaysOfWeekEnum.Wednesday,
		index: 3,
		shortName: 'Wed',
	},
	{
		id: DaysOfWeekEnum.Thursday,
		index: 4,
		shortName: 'Thu',
	},
	{
		id: DaysOfWeekEnum.Friday,
		index: 5,
		shortName: 'Fri',
	},
	{
		id: DaysOfWeekEnum.Saturday,
		index: 6,
		shortName: 'Sat',
	},
];
